// Lightweight, fire-and-forget marketing event tracker.
// Anonymous: no PII, just event_type + UTM params + referrer (captured server-side).
// Used by /landing and /tour to measure tour engagement.

const VALID_EVENTS = new Set([
  'tour_view',
  'tour_complete',
  'tour_skip',
  'tour_cta_click',
  'landing_view',
]);

function readUtmParams() {
  if (typeof window === 'undefined') return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((k) => {
      const v = params.get(k);
      if (v) out[k] = v.slice(0, 120);
    });
    return out;
  } catch (e) {
    return {};
  }
}

export function trackMarketingEvent(eventType, extra = {}) {
  if (!VALID_EVENTS.has(eventType)) return;
  const base = process.env.REACT_APP_BACKEND_URL;
  if (!base) return;
  const body = JSON.stringify({
    event_type: eventType,
    page: typeof window !== 'undefined' ? window.location.pathname : null,
    referrer: typeof document !== 'undefined' ? document.referrer || null : null,
    ...readUtmParams(),
    ...extra,
  });
  try {
    // Prefer sendBeacon when available so we still log on page-unload (tour completion)
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      const ok = navigator.sendBeacon(`${base}/api/marketing/event`, blob);
      if (ok) return;
    }
    fetch(`${base}/api/marketing/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // Silent — analytics must never break user flow
  }
}
